<template>
  <OutgoingReturnForm
    formTitle="Buat Retur Supplier"
    defaultDescription="Supplier"
  />
</template>

<script>
import OutgoingReturnForm from './OutgoingReturnForm.vue'
export default {
  components: { OutgoingReturnForm }
}
</script>
